module.exports = __webpack_public_path__ + "static/media/blik.d405b8d2.svg";